export const URLS = {
	CAMPAIGN: 'campaign',
	BUYOUT_STATES: 'type-states',
	BUYOUT_QUALITIES: 'type-qualities',
	PRODUCT_CATEGORIES: 'product-categories',
	PRODUCT_MANUFACTURERS: 'type-manufacturers',
	PRODUCT_MODELS: 'master-products',
	PRODUCT_COLORS: 'product-colors',
	APPRAISAL: 'appraisal',
	BUYOUT: 'buyout',
	INFO_BUYOUT: 'info-buyout',
	BUYOUT_INFO: 'buyout-info',
	GET_BUYOUT_STATE: 'buyout/get-buyout-state',
	APPRAISAL_GENDERS: 'type-genders',
	APPRAISAL_STATES: 'type-countries',
	FAQS: 'faqs',
	ACTIVE_FAQS: 'active-faqs',
	EDITOR_TEXT_BLOCK: 'editor/text',
	EDITOR_BANNER_BLOCK: 'editor/banner',
	HOW_IT_WORKS: 'how-it-works',
	BONUS_DATA: 'get-bonus-data',
	PARTNERS: 'partners',
	PICKUP_ADDRESS: 'pickup-address',
	UPLOAD_RECIEPT: 'upload-receipt',
	ADDITIONAL_INFO: 'additional-info',
	BUYOUT_GAMING: 'buyout/gaming',
	GAMING_ACCESSORY: 'gaming-accessory',
	XBOX_LICENCE: 'get-atc-product-licence'
}
